var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distribution",attrs:{"id":_vm.distributionData.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }